/**
 * Takes a string and converts its first character to lower case.
 *
 * ```ts
 * tt.uncapitalize('Hello, world');
 * // => 'hello, world'
 * ``
 */
export function uncapitalize(s: string) {
  return s && s.length > 0 ? s[0].toLowerCase() + s.slice(1) : '';
}
